import {
  NodeAnnualReport,
  NodeArticle,
  NodeBasicPage,
  NodeEquipment,
  NodeHomePage,
  NodeLandingPage,
  NodeOverviewPage,
  NodeProject,
} from '../implementations';

const mappers = {
  annual_report: NodeAnnualReport,
  article: NodeArticle,
  basic_page: NodeBasicPage,
  equipment: NodeEquipment,
  homepage: NodeHomePage,
  landing_page: NodeLandingPage,
  overview_page: NodeOverviewPage,
  project: NodeProject,
};

export default mappers;
